import { Row } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import { TimeType, Trigger, TriggerType } from 'models/automation/Triggers';
import { TriggerConditionFormValue } from '../../modal/TriggerAddEditModal.schema.utils';
import { parseConditionsToFormValues } from '../../modal/TriggerAddEditModal.utils';

interface TriggerTypeCellProps {
  getValue: () => Trigger['triggerType'];
  row: Row<Trigger>;
}

const formatTimeAndType = ({
  timeInMilliSeconds,
  timeType,
}: Pick<TriggerConditionFormValue, 'timeInMilliSeconds' | 'timeType'>) => {
  const timeFormatted = `${timeInMilliSeconds ?? ''}`;

  switch (timeType) {
    case TimeType.DAYS:
      return `${timeFormatted}d`;

    case TimeType.HOURS:
      return `${timeFormatted}h`;

    case TimeType.MINUTES:
      return `${timeFormatted}m`;

    default:
      return timeFormatted;
  }
};

const TriggerTypeCell = ({ getValue, row }: TriggerTypeCellProps) => {
  const { t } = useTranslation();
  const type = getValue();

  if (type === TriggerType.TIME_BASED) {
    const { timeCondition } = parseConditionsToFormValues({
      allLeadChannels: undefined,
      allProperties: undefined,
      condition: row.original.condition,
      t,
    });

    return t('pageAutomations.triggers.table.conditionType', {
      context: timeCondition.condition.conditionType,
      value: formatTimeAndType(timeCondition.condition),
    });
  }

  return t('pageAutomations.triggers.eventType', {
    context: row.original.eventType,
  });
};

export default TriggerTypeCell;
